import React, { Component } from 'react';
import styled from 'styled-components';

export default class StepButton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const active = this.props.index === this.props.currentActive;
    const inactive = this.props.index > this.props.currentActive;

    const imageSrc = active
      ? '/images/redesign/navbar/step1.png'
      : inactive
        ? '/images/redesign/navbar/step2.png'
        : '/images/redesign/navbar/step3.png';

    return (
      <div style={{
        backgroundColor: 'none',
        width: 75,
        height: 75,
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: -10,
        // justifyContent: 'center',
        // alignItems: 'center',
       }} onClick={this.props.onClick}>
        <div style={{
          // position: 'absolute',
          margin: 'auto',
          marginTop: 0,
        }}>
          <StepLabel
            color={active ? 'white' : '#aec0f5'}
            fontWeight={active || this.props.index < this.props.currentActive ? 'bold' : 'normal'}
          >{this.props.step.name.toUpperCase()}</StepLabel>
        </div>
        <div style={{ width: 40, height: 40, margin: 'auto' }}>
          <Image src={imageSrc}/>
          { active || inactive ? (
            <div style={{ position: 'relative', width: 40, height: 40, justifyContent: 'center', alignItems: 'center', display: 'flex', top: -40 }}>
              <StepNumber
                color={active ? '#4c73fc' : '#afafaf'}
              >{this.props.index + 1}</StepNumber>
            </div> 
          ) : null }
        </div>
      </div>
    );
  }
}

const Image = styled.img`
	display: block;
	height: auto;
	width: 100%;
`;

const StepNumber = styled.div`
  font-family: 'Karla', sans-serif;
  font-size: 18px;
  font-weight: bold;
  color: ${props => props.color};
`;

const StepLabel = styled.div`
  font-family: 'Karla', sans-serif;
  font-size: 14px;
  text-align: center;
  font-weight: ${props => props.fontWeight}
  color: ${props => props.color};
`;



// WEBPACK FOOTER //
// ./client/redesign/signup/Main/Navbar/StepButton/index.js